module.exports = __webpack_public_path__ + "static/media/bongo-cat.a0d5cc15.gif";